import { isAllowed } from '@ion/api/Apollo/allower';
import permissions from '@ion/api/Apollo/permissions';

export default function isAllowedToDeleteInvitation() {
  return isAllowed(permissions.deleteUsers);
}
